import axiosClient from "@/utils/axios-client";
import {
  BuyerBankInfoResponse,
  BuyerRemitterNameResponse,
} from "@/shared/api/bank-info/types";
import { bankInfoUrl } from "@/shared/api/bank-info/url";

export const bankInfoQueryApi = {
  // 바이어 기본 환불 계좌 조회 — 미등록이면 404가 아니라 200 + null이 온다.
  getBuyerBankInfo: async (buyerId: number) => {
    const { data } = await axiosClient.get<BuyerBankInfoResponse | null>(
      bankInfoUrl.root(buyerId)
    );
    return data;
  },
  // 바이어 기본 입금자명 조회 — 한 번도 적은 적이 없으면 remitter_name 이 null 이다.
  getBuyerRemitterName: async (buyerId: number) => {
    const { data } = await axiosClient.get<BuyerRemitterNameResponse>(
      bankInfoUrl.remitterName(buyerId)
    );
    return data;
  },
};
